<template>
  <v-app>
    <SkipLink />
    <v-main>
      <header>
        <h1 class="text-h6 font-weight-bold text-center pa-2 ma-0">
          {{ $city.name }}成人健康篩檢站現場掛號表單
        </h1>
      </header>
      <v-container id="main-content" tabindex="-1">
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import SkipLink from "@/components/Common/SkipLink.vue";

export default {
  components: {
    SkipLink,
  },
  created() {},
  methods: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
header {
  background-color: #0f4c81;
  color: #fff;
  // line-height: 52px;
}
</style>
